module.exports = __webpack_public_path__ + "static/img/12.56c7f11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/12.jpg
// module id = uHTX
// module chunks = 0